//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'vheader',
  props:{
    bgcolor:{
      type: String,
      default: '#fff'
    },
    color:{
      type: String,
      default: '#323233'
    },
    title:{
      type: String,
      default: ''
    },
    showLeft:{
      type: Boolean,
      default: true
    },
    backFun:{
      type: Function
    }
  },
  methods:{
    goBack(){
      if(this.backFun){
        this.backFun()
        return false;
      }
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        wx.miniProgram.getEnv((res) => {
          if(res.miniprogram) {
            console.log('在小程序内');
            wx.miniProgram.navigateBack();
          } else {
            this.$router.go(-1);
          }
        });
        return false;
      }
      this.$router.go(-1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/header/index.vue